module.exports = __webpack_public_path__ + "img/other_pay_alipay2.f6597c0e.svg";